<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Votre liste d'amis sur Zikmate</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col cols="12" sm="10" offset-sm="1" md="8" offset-md="2">
          <b-card no-body>
            <b-tabs pills card>
              <b-tab title="Amis" active>
                <AcceptedFriends/>
              </b-tab>
              <b-tab title="En attente">
                <PendingFriends/>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import AcceptedFriends from "./AcceptedFriends.vue";
import PendingFriends from "./PendingFriends.vue";

export default {
  name: "Friends",
  components: {
    AcceptedFriends,
    PendingFriends
  }
};
</script>
